import React from "react";
import styled, { css } from "styled-components";
import { Box } from "../Box";
const StyledBox = styled(Box)(({ theme: { colors: { searchBoxColors }, sizes, }, }) => ({
    background: searchBoxColors.dropdownTitleBackground,
    borderTopLeftRadius: sizes[1],
    borderTopRightRadius: sizes[1],
    color: searchBoxColors.dropdownTitleText,
    padding: "7px 12px",
}));
const StyledArrowBox = styled(Box)(({ theme: { colors: { searchBoxColors }, }, }) => css `
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    top: -7px;
    left: 20px;
    margin-left: -11px;
    border-width: 0 7px 7px;
    border-style: solid;
    border-color: transparent transparent ${searchBoxColors.arrowContainerBorder};
    border-image: initial;

    &::after {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      top: 1px;
      content: " ";
      margin-left: -6px;
      border-width: 0 6px 6px;
      border-style: solid;
      border-color: transparent transparent ${searchBoxColors.arrowBorder};
      border-image: initial;
      border-bottom-color: ${searchBoxColors.arrow};
    }
  `);
export const SearchDropdownTitle = ({ title }) => title && (React.createElement(React.Fragment, null,
    React.createElement(StyledArrowBox, { "data-testid": "searchDropdownTitleArrowBox" }),
    React.createElement(StyledBox, { p: "2", "data-testid": "searchDropdownTitleBox" }, title)));
